import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { HomeIcon, UsersIcon, ArrowPathIcon, Cog6ToothIcon, AcademicCapIcon, BriefcaseIcon } from '@heroicons/react/24/outline';

const AdminNavbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/admin/login');
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const navLinks = [
        { path: '/admin', label: 'Dashboard', icon: HomeIcon },
        { path: '/admin/seo', label: 'SEO', icon: Cog6ToothIcon },
        { path: '/admin/legal-professionals', label: 'Legal Professionals', icon: AcademicCapIcon },
        { path: '/admin/managers', label: 'Managers', icon: BriefcaseIcon },
        { path: '/admin/users', label: 'Users', icon: UsersIcon },
        { path: '/admin/sra-sync', label: 'SRA Sync', icon: ArrowPathIcon },
    ];

    return (
        <nav className="bg-white shadow-sm sticky top-0 z-999">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <div className="flex-shrink-0 flex items-center">
                            <h1 className="text-xl font-bold text-gray-800 mb-0">Admin</h1>
                        </div>
                        <div className="hidden sm:ml-6 sm:flex sm:space-x-4">
                            {navLinks.map((link) => {
                                const Icon = link.icon;
                                return (
                                    <Link
                                        key={link.path}
                                        to={link.path}
                                        className={`inline-flex items-center px-3 py-2 text-sm font-medium ${
                                            location.pathname === link.path
                                                ? 'text-blue-600 border-b-2 border-blue-600'
                                                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                        }`}
                                    >
                                        <Icon className="h-5 w-5 mr-2" />
                                        {link.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex items-center">
                        <span className="text-gray-700 mr-4">Welcome, {user?.username}</span>
                        <button
                            onClick={handleLogout}
                            className="btn btn--secondary"
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </div>
            {/* Mobile menu */}
            <div className="sm:hidden">
                <div className="px-2 pt-2 pb-3 space-y-1">
                    {navLinks.map((link) => {
                        const Icon = link.icon;
                        return (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`flex items-center px-3 py-2 text-base font-medium ${
                                    location.pathname === link.path
                                        ? 'text-blue-600 bg-blue-50'
                                        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                }`}
                            >
                                <Icon className="h-5 w-5 mr-2" />
                                {link.label}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </nav>
    );
};

export default AdminNavbar; 